// extracted by mini-css-extract-plugin
module.exports = {"lead_form_saving":"lead_form_saving"};